(function(){
  'use strict';

  /** Checkout button */
  class CheckoutButton extends HTMLElement {
    constructor() {
      super();

      this.lock = false;
      this.variantId = this.getAttribute('variant');
    }
    connectedCallback() {
      this.addEventListener('click', this._buyNow.bind(this));
    }
    async _buyNow(e) {
      e.preventDefault();

      if (!this.variantId) {
        return;
      }

      if (this.lock == true) {
        return;
      }

      try {
        this.lock = true;

        this.classList.add('loading');

        await fetch('/cart/add.js', {
          method: 'post',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: this.variantId,
            quantity: 1,
          }),
        })
          .then((r) => {
            document.documentElement.classList.toggle('invisible');
            return r.json();
          })
          .then(() => {
            setTimeout(() => {
              window.location.href = window.location.origin + '/checkout';
            }, 300);
          });
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('checkout-button')) {
    window.customElements.define('checkout-button', CheckoutButton);
  }

  /** Back to the top */
  class BackToTop extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      window.addEventListener('DOMContentLoaded', this.show.bind(this));
      window.addEventListener('scroll', this.show.bind(this));
      this.addEventListener('click', this.click.bind(this));
    }
    show() {
      try {
        const documentHeight = document.documentElement.scrollHeight;
        const footerHeight = document.querySelector('.new-footer').offsetHeight;
        const footerTop = documentHeight - footerHeight - window.screen.availHeight;
        
        if (window.scrollY >= footerTop ) {
          this.classList.add('show');
        } else {
          this.classList.remove('show');
        }
      } catch (err) {
        console.error(err);
      }
    }
    click() {
      window.scroll(0,0);
    }
  }
  if (!window.customElements.get('back-to-top')) {
    window.customElements.define('back-to-top', BackToTop);
  }

  /** Line item buttom */
  class LineItemButton extends HTMLElement {
    constructor() {
      super();
      
      this.button = this.querySelector('button');
      this.onClickListener = this._onClickListener.bind(this);
    }
    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', this.onClickListener);
      }
    }
    _onClickListener(e) {
      let quantity;

      e.preventDefault();

      const lineItem = this.closest('line-item-quantity');
      const quantityInput = lineItem.querySelector('.quantity-input');
      const action = this.dataset.action;

      lineItem.querySelectorAll('button,input').forEach(el => el.disabled = true);

      switch(action) {
        case 'minus':
          if (quantityInput.value == 1) {
            return;
          }

          quantity = parseInt(quantityInput.value);
          quantity--;
          quantity = Math.max(1, quantity);
          quantityInput.value = quantity;

          quantityInput.dispatchEvent(new Event('change', {
            bubbles: true
          }))
        break;
      
        case 'plus':
          quantity = parseInt(quantityInput.value);
          quantity++;
          quantityInput.value = quantity;
          quantityInput.dispatchEvent(new Event('change', {
            bubbles: true
          }));
        break;
      }
    }
  }
  
  if (!window.customElements.get('line-item-button')) {
    window.customElements.define('line-item-button', LineItemButton);
  }


  class DiscountField extends HTMLElement {
    constructor() {
      super();

      this.input = this.querySelector('input');
      this.form = this.querySelector('form');
      this.button = this.querySelector('button');
    }
    connectedCallback() {
      this.form.addEventListener('submit', this.submit.bind(this));
    }
    submit(e) {
      e.preventDefault();
      try {
        const discountCode = this.input.value;

        if (discountCode !== '') {
          window.location.href = `/discount/${discountCode}?redirect=${window.location.pathname}`;
        } else {
          this.button.removeAttribute("aria-busy");
        }
      } catch(err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('discount-field')) {
    window.customElements.define('discount-field', DiscountField);
  }
})();
